<template>
  <div class="full-width">
    <q-form
      @submit="onSubmit"
    >
      <div class="column q-mt-lg">
        <AppInput
          ref="email"
          v-model="form.email"
          :label="$t('label.email')"
          :rules="[RULES.REQUIRED, RULES.EMAIL]"
          lazy-rules
          outlined
          :placeholder="$t('placeholder.email')"
        >
          <template v-slot:append>
            <q-icon
              color="primary"
              name="mail"
            />
          </template>
        </AppInput>
        <AppInput
          ref="password"
          v-model="form.password"
          :label="$t('label.password')"
          :rules="[RULES.REQUIRED]"
          :type="isHidePassword ? 'password' : 'text'"
          class="q-mt-md"
          icon="mail"
          lazy-rules
          outlined
          :placeholder="$t('placeholder.password')"
        >
          <template v-slot:append>
            <q-icon
              :name="isHidePassword ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              color="primary"
              @click="isHidePassword = !isHidePassword"
            />
          </template>
        </AppInput>
        <AppInput
          ref="passwordConfirm"
          v-model="confirmPassword"
          :label="$t('label.passwordConfirmation')"
          :rules="[RULES.REQUIRED, val => val === form.password
            || $t('error.passwordIsNotMatched')]"
          :type="isHidePassword ? 'password' : 'text'"
          class="q-mt-md"
          icon="mail"
          lazy-rules
          outlined
          :placeholder="$t('placeholder.password')"
        >
          <template v-slot:append>
            <q-icon
              :name="isHidePassword ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              color="primary"
              @click="isHidePassword = !isHidePassword"
            />
          </template>
        </AppInput>
        <q-field
          ref="checkbox"
          :rules="[RULES.BOOLEAN_REQUIRED]"
          :value="confirmTerms"
          borderless
          class="q-mt-md q-mb-lg"
          dense
          hide-bottom-space
        >
          <template v-slot:control>
            <AppCheckbox
              v-model="confirmTerms"
              :label="$t('label.iAgreeWithTerms')"
            />
          </template>
        </q-field>
      </div>
      <div class="row q-mt-sm">
        <div class="col-12 col-lg-5">
          <AppButton
            :loading="loading"
            :disabled="loading"
            :label="$t('button.next')"
            icon-right="navigate_next"
            type="submit"
            full-width
          />
        </div>
      </div>
    </q-form>
    <q-separator
      class="q-mt-lg"
      color="grey-2"
      dark
    />
    <div class="flex justify-between items-center q-my-xl">
      <div class="text-16-400 text-grey">
        {{ $t('text.alreadyHaveAccount') }}
      </div>
      <div>
        <AppButtonLink
          :label="$t('button.login')"
          :to="toLogin"
          class="text-16-400 q-ml-xl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppCheckbox from 'common/components/AppCheckbox';
import AppInput from 'common/components/AppInput';
import AppButton from 'common/components/buttons/AppButton';
import AppButtonLink from 'common/components/buttons/AppButtonLink';
import handleError from 'common/helpers/handleError';
import { notifySuccess } from 'common/helpers/notify';
import rules from 'common/helpers/rules';
import { mapActions } from 'vuex';

export default {
  name: 'SignUpForm',
  components: {
    AppButtonLink,
    AppCheckbox,
    AppInput,
    AppButton,
  },
  props: {
    owner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        email: undefined,
        password: undefined,
        communityId: this.$community.id,
      },
      confirmPassword: undefined,
      confirmTerms: false,
      isHidePassword: true,
      loading: false,
    };
  },
  computed: {
    RULES: () => rules,
    toLogin() {
      return { name: this.owner ? ENUMS.ROUTES.AUTH.SIGNIN : ENUMS.ROUTES.AUTH.SIGNIN_COMMUNITY };
    },
  },
  methods: {
    ...mapActions('app', ['signup']),
    // eslint-disable-next-line consistent-return
    async onSubmit() {
      try {
        this.loading = true;

        await this.signup({
          form: this.form,
        });
        notifySuccess(this.$t('Success'));

        if (this.owner) {
          return this.$router.push({ name: ENUMS.ROUTES.DASHBOARD.INDEX });
        }

        const { communitySlug } = this.$route.params;
        window.location.href = `/${communitySlug}`;
      } catch (error) {
        console.error(error);
        handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
